module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2), exports);
tslib_1.__exportStar(__webpack_require__(3), exports);
tslib_1.__exportStar(__webpack_require__(4), exports);
tslib_1.__exportStar(__webpack_require__(5), exports);
tslib_1.__exportStar(__webpack_require__(6), exports);
tslib_1.__exportStar(__webpack_require__(7), exports);
tslib_1.__exportStar(__webpack_require__(8), exports);
tslib_1.__exportStar(__webpack_require__(9), exports);
tslib_1.__exportStar(__webpack_require__(10), exports);
tslib_1.__exportStar(__webpack_require__(11), exports);
tslib_1.__exportStar(__webpack_require__(12), exports);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultCookieOptions = {
    domain: '.cian.ru',
    path: '/',
    secure: true,
};
exports.setCookie = function (name, value, config) {
    var options = Object.assign({}, defaultCookieOptions, config);
    var expires = options.expires;
    var cookieExpires;
    if (expires) {
        if (typeof expires === 'number') {
            var d = new Date();
            cookieExpires = new Date(d.setTime(d.getTime() + expires * 1000)).toUTCString();
        }
        else if (expires instanceof Date) {
            cookieExpires = expires.toUTCString();
        }
    }
    document.cookie =
        // tslint:disable-next-line:prefer-template
        name + "=" + encodeURIComponent(value) + "; " +
            ("path=" + options.path) +
            ("; domain=" + options.domain) +
            (cookieExpires ? "; expires=" + cookieExpires : '') +
            (options.secure ? "; secure" : '');
};
exports.deleteCookie = function (name, config) {
    exports.setCookie(name, '', Object.assign({}, config, {
        expires: -1,
    }));
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var hostPatterns = [
    ['beta', /stage\.cian\.ru$/i],
    ['development', /dev[2,3]?\.cian\.ru$/i],
    ['local', /local(\.map)?\.cian\.ru$/i],
    ['local', /^localhost(:\d+)?$/i],
    ['production', /cian\.ru$/i],
];
function calculateEnvironmentByHost(host) {
    for (var _i = 0, hostPatterns_1 = hostPatterns; _i < hostPatterns_1.length; _i++) {
        var hostPattern = hostPatterns_1[_i];
        if (hostPattern[1].test(host)) {
            return hostPattern[0];
        }
    }
    return 'unknown';
}
exports.calculateEnvironmentByHost = calculateEnvironmentByHost;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookies = function (cookiesString) {
    var cookiesObject = {};
    var pairs = cookiesString.split(/; */);
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var eqIdx = pair.indexOf('=');
        // skip things that don't look like key=value
        if (eqIdx < 0) {
            continue;
        }
        var key = pair.substr(0, eqIdx).trim();
        // tslint:disable-next-line:restrict-plus-operands
        var value = pair.substr(eqIdx + 1, pair.length).trim();
        // quoted values
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        // only assign once
        if (!(key in cookiesObject)) {
            cookiesObject[key] = decodeURIComponent(value);
        }
    }
    return cookiesObject;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];
function isValidDate(date) {
    return !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
function leftPadZero(value) {
    if (value < 10) {
        return "0" + value;
    }
    return value.toString();
}
exports.leftPadZero = leftPadZero;
function getTime(date) {
    return leftPadZero(date.getHours()) + ":" + leftPadZero(date.getMinutes());
}
exports.getTime = getTime;
function mapDayToString(date, now) {
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (now.getFullYear() !== date.getFullYear() || now.getMonth() !== date.getMonth()) {
        return undefined;
    }
    if (now.getDate() === date.getDate()) {
        return 'сегодня';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'вчера';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'позавчера';
    }
    return undefined;
}
exports.mapDayToString = mapDayToString;
function getFormattedDate(date, now) {
    var day = mapDayToString(date);
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (day) {
        return day + " " + getTime(date);
    }
    if (now.getFullYear() === date.getFullYear()) {
        return date.getDate() + " " + monthNames[date.getMonth()] + " " + getTime(date);
    }
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
}
exports.getFormattedDate = getFormattedDate;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var devices = [
    {
        regex: /iPhone/i,
        type: 'phone',
    }, {
        regex: /iPod/i,
        type: 'phone',
    }, {
        regex: /iPad/i,
        type: 'tablet',
    }, {
        regex: /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /Android/i,
        type: 'tablet',
    }, {
        regex: /Windows Phone/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
        type: 'tablet',
    }, {
        regex: /(BlackBerry|BB10)/i,
        type: 'phone',
    }, {
        regex: /Opera Mini/i,
        type: 'phone',
    }, {
        regex: /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    },
];
exports.identifyDeviceType = function (userAgent) {
    if (userAgent) {
        for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.regex.test(userAgent)) {
                return device.type;
            }
        }
    }
    return 'desktop';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function normalizeHost(host) {
    var rules = [
        [/^([^\.]+)\.micro\.cian\.tech$/, undefined],
        [/^(?:[^\.]+\.)?beta\d*\.stage\.cian\.ru$/, 'python'],
        [/^[^\.]+\.([^\.]+)\.stage\.cian\.ru$/, undefined],
        [/^(?:[^\.]+\.)?[^\.]+\.dev\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?beta\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?cian\.ru$/, 'python'],
    ];
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var _a = rules_1[_i], pattern = _a[0], name_1 = _a[1];
        var matches = pattern.exec(host);
        if (matches) {
            if (name_1) {
                return name_1;
            }
            else {
                return matches[1];
            }
        }
    }
    return host;
}
exports.normalizeHost = normalizeHost;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NOT_NUMBER_REX = /[^0-9]/g;
var NUMBER_GROUP_REX = /.{1,3}/g;
function parseNumber(s) {
    var sign = s[0] === '-' ? '-' : '';
    var _a = s.split('.'), integer = _a[0], fractional = _a[1];
    return {
        fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
        integer: integer.replace(NOT_NUMBER_REX, ''),
        sign: sign,
    };
}
exports.parseNumber = parseNumber;
function numberToPrettyString(defaultNumber, separator) {
    if (separator === void 0) { separator = ','; }
    var _a = parseNumber(String(defaultNumber)), fractional = _a.fractional, integer = _a.integer, sign = _a.sign;
    var parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
    var prettyInteger = parsedInteger.reverse().map(reverseString).join(' ');
    return !fractional ? "" + sign + prettyInteger : "" + sign + prettyInteger + separator + fractional;
}
exports.numberToPrettyString = numberToPrettyString;
function reverseString(s) {
    return s.split('').reverse().join('');
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function plural(n, variants) {
    if (n % 10 === 1 && n % 100 !== 11) {
        return variants[0];
    }
    if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return variants[1];
    }
    return variants[2];
}
exports.plural = plural;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    if (params.center) {
        params.containerElement.scrollTop =
            targetElementOffsetTop
                - containerElementClientHeight / 2
                + targetElementScrollHeight / 2;
    }
    else {
        var containerBottom = containerElementScrollTop + containerElementClientHeight;
        var valueBottom = targetElementOffsetTop + targetElementScrollHeight;
        if (valueBottom > containerBottom) {
            params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
        }
        else if (targetElementOffsetTop < containerElementScrollTop) {
            params.containerElement.scrollTop = targetElementOffsetTop;
        }
    }
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    billionPostfix: 'млрд.',
    fractionalLength: 2,
    millionPostfix: 'млн.',
    separator: undefined,
    thousandPostfix: 'тыс.',
};
function shortenNumber(i, userOptions) {
    var options = userOptions
        ? Object.assign({}, defaultOptions, userOptions)
        : defaultOptions;
    var getFractional = fractional(options.fractionalLength);
    var applyPostfix = withPostfix(options.separator);
    if (i >= 1000000000) {
        var value = getFractional(i, 1000000000);
        return applyPostfix(value, options.billionPostfix);
    }
    else if (i >= 1000000) {
        var value = getFractional(i, 1000000);
        return applyPostfix(String(value), options.millionPostfix);
    }
    else if (i >= 1000) {
        var value = getFractional(i, 1000);
        return applyPostfix(value, options.thousandPostfix);
    }
    else {
        var value = getFractional(i);
        return applySeparator(Number(value), options.separator);
    }
}
exports.shortenNumber = shortenNumber;
function withPostfix(separator) {
    return function (value, postfix) {
        return applySeparator(Number(value), separator) + " " + postfix;
    };
}
function fractional(fractionalLength) {
    return function (value, divider) {
        if (!divider) {
            return value.toFixed(fractionalLength);
        }
        var num = value / divider;
        var numAsArray = String(num).split('.');
        var originalFractionChapter = numAsArray[1];
        if (originalFractionChapter &&
            originalFractionChapter.length > 2 &&
            Number(originalFractionChapter.slice(-1)) < 5) {
            return num.toFixed(fractionalLength);
        }
        else if (originalFractionChapter) {
            var newFractionChapter = originalFractionChapter.length > fractionalLength
                ? originalFractionChapter.slice(0, fractionalLength)
                : originalFractionChapter;
            return numAsArray[0] + "." + newFractionChapter;
        }
        return String(num);
    };
}
function applySeparator(value, separator) {
    if (typeof separator === 'string') {
        return value.toString().replace('.', separator);
    }
    return value.toString();
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function isStyleProps(styleArgument) {
    if (!!styleArgument && typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
function mergeClassNames(target, cls) {
    if (!cls || !cls.length) {
        return target;
    }
    return target.length === 0
        ? cls
        : target + " " + cls;
}
function mergeStyleProperties(target, style) {
    return tslib_1.__assign({}, target, style);
}
function mergerStyleConfigs(target, style) {
    return {
        className: mergeClassNames(target.className, style.className),
        style: mergeStyleProperties(target.style, style.style),
    };
}
// tslint:disable-next-line:no-any
function isStyleConifg(target) {
    if (!target) {
        return false;
    }
    return typeof target === 'object' || typeof target === 'string';
}
function reducer(acc, style) {
    if (!isStyleConifg(style)) {
        return acc;
    }
    if (Array.isArray(style)) {
        return style.reduce(reducer, acc);
    }
    if (typeof style === 'object') {
        return isStyleProps(style)
            ? mergerStyleConfigs(acc, style)
            : mergerStyleConfigs(acc, { className: '', style: style });
    }
    acc.className = mergeClassNames(acc.className, style);
    return acc;
}
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reducer, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;


/***/ })
/******/ ]);
//# sourceMappingURL=frontend-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@cian/utils/dist/frontend-utils.js
// module id = 75
// module chunks = 0